import React from 'react';
import { 
  Film, 
  Tv, 
  ShieldCheck, 
  Globe, 
  MessageSquare,
  ChevronRight,
  LayoutGrid,
  Send
} from 'lucide-react';
import { motion } from 'framer-motion';

const links = [
  {
    title: '✈️ Бесплатный прокси для TG',
    url: 'tg://proxy?server=mtp.insuteam.xyz&port=443&secret=7lox3lNQ-YexKYwGa5tAnsVtdHAuaW5zdXRlYW0ueHl6',
    icon: <Send className="text-[#24A1DE]" size={20} />,
    description: 'Нажми, чтобы подключить быстрый MTProxy для Telegram.',
    gradient: 'from-[#24A1DE]/20 to-[#0088cc]/20'
  },
  {
    title: '🍿 Бот с фильмами',
    url: 'https://t.me/FreeInsuFilmsBot?start=997_26866056',
    icon: <Film className="text-[#ff4d4d]" size={20} />,
    description: 'Смотрите новинки кино и сериалов в HD качестве прямо в Telegram.',
    gradient: 'from-red-500/20 to-orange-500/20'
  },
  {
    title: '📢 Канал InsuFilms',
    url: 'https://t.me/+vjRhl4rIJhY1OWUy',
    icon: <Tv className="text-blue-400" size={20} />,
    description: 'Официальный канал проекта InsuFilms.',
    gradient: 'from-blue-500/20 to-cyan-500/20'
  },
  {
    title: '🌐 Купить VPN на нашем сайте',
    url: 'https://web.insuteam.xyz/?ref=INSU-B6297A3F',
    icon: <Globe className="text-amber-400" size={20} />,
    description: 'Купить быстрый и надежный VPN на нашем официальном сайте.',
    gradient: 'from-amber-500/20 to-yellow-500/20'
  },
  {
    title: '🛡️ Бот InsuVPN в TG',
    url: 'https://t.me/InsuVPNBot?start=referral_INSU-B6297A3F',
    icon: <ShieldCheck className="text-emerald-400" size={20} />,
    description: 'Бесплатный период до 14 дней 🎁',
    gradient: 'from-emerald-500/20 to-teal-500/20'
  },
  {
    title: '📰 Канал InsuVPN',
    url: 'https://t.me/+rgzW_N3oDn1jNDZi',
    icon: <MessageSquare className="text-purple-400" size={20} />,
    description: 'Официальный канал проекта InsuVPN.',
    gradient: 'from-purple-500/20 to-pink-500/20'
  }
];

function App() {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-red-500/30 font-sans relative overflow-hidden flex flex-col items-center py-20 px-6">
      
      {/* Фоновая анимация свечения */}
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-red-600/[0.03] rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-blue-600/[0.03] rounded-full blur-[120px] animate-pulse delay-1000"></div>

      {/* Header */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="flex flex-col items-center mb-16 z-10 text-center"
      >
        <div className="relative inline-block mb-10 group">
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-[-0.04em] leading-none text-white">
            Insu<span className="text-[#ff4d4d]" style={{ textShadow: '0 0 15px rgba(255, 77, 77, 0.4)' }}>Team</span>
          </h1>
          <div className="absolute -bottom-3 left-[10%] w-[80%] h-[1px] bg-gradient-to-r from-transparent via-white to-transparent shadow-[0_0_20px_#fff] animate-glow"></div>
        </div>
        
        <div className="flex items-center gap-2.5 py-2 px-6 bg-white/[0.03] rounded-full border border-white/10 backdrop-blur-md shadow-2xl">
          <LayoutGrid size={12} className="text-red-500" />
          <span className="text-[11px] text-gray-400 font-bold uppercase tracking-[0.25em]">Наши сервисы</span>
        </div>
      </motion.div>

      {/* Links Grid */}
      <div className="w-full max-w-[370px] space-y-3.5 z-10">
        {links.map((link, index) => (
          <motion.a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            className="group relative block w-full"
          >
            <div className={`absolute inset-0 bg-gradient-to-r ${link.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-700 rounded-2xl blur-2xl`}></div>
            
            <div className="glass glass-hover p-4 flex items-center gap-4 transition-all duration-300 relative overflow-hidden group-active:scale-[0.97]">
              <div className="w-11 h-11 min-w-[44px] rounded-xl bg-white/[0.03] flex items-center justify-center group-hover:bg-white/[0.06] transition-colors border border-white/5">
                {link.icon}
              </div>
              
              <div className="flex-1 text-left">
                <h3 className="font-bold text-[15px] group-hover:text-sky-400 transition-colors leading-tight tracking-tight">
                  {link.title}
                </h3>
                <p className="text-[12px] text-gray-500 leading-snug mt-1 opacity-80 group-hover:opacity-100 transition-all font-medium">
                  {link.description}
                </p>
              </div>

              <div className="opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-500">
                <ChevronRight size={16} className="text-white/30" />
              </div>
            </div>
          </motion.a>
        ))}
      </div>

      {/* Footer */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="mt-24 text-center z-10"
      >
        <p className="text-gray-600 text-[10px] uppercase tracking-[0.5em] font-black">
          Powered by InsuTeam
        </p>
      </motion.div>

    </div>
  );
}

export default App;
